"use strict";
/**
 * Created by Marvin Ruppelt on 13.03.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var FormErrors = function (errors) {
    var FieldError = function (_a) {
        var name = _a.name;
        if (!errors || !Object.keys(errors).length)
            return null;
        if (errors.hasOwnProperty('fatal') && errors.fatal[name] || false) {
            return react_1["default"].createElement("div", { className: "text-danger form-error form-error--fatal" }, errors.fatal[name][0]);
        }
        if (errors.hasOwnProperty('errors') && errors.errors[name] || false) {
            return react_1["default"].createElement("div", { className: "text-danger form-error" }, errors.errors[name][0]);
        }
        if (errors.hasOwnProperty('warnings') && errors.warnings[name] || false) {
            return react_1["default"].createElement("div", { className: "text-warning form-error" }, errors.warnings[name][0]);
        }
        if (errors.hasOwnProperty('infos') && errors.infos[name] || false) {
            return react_1["default"].createElement("div", { className: "text-muted form-error" }, errors.infos[name][0]);
        }
        return null;
    };
    return {
        FieldError: FieldError,
        RenderError: FieldError,
        //hat schwerwiegenden fehler
        hasErrors: function () {
            return (errors && errors.hasOwnProperty('fatal') && Object.keys(errors.fatal).length > 0);
        },
        // wurde geprüft -> errors gesetzt und array
        isValidated: function () { return errors && Object.keys(errors).length > 0; }
    };
};
exports["default"] = FormErrors;
